import { array } from 'common/helpers/primitives'


export const initialState = {
  items: [],
  selectedIds: [],
}

export const setItems = (state, payload) => ({ ...state, items: payload })

export const toggleSelectedId = (state, payload) => ({
  ...state,
  selectedIds: array.toggle(state.selectedIds, payload),
})

export const resetSelectedIds = (state) => ({ ...state, selectedIds: [] })
